import clsx from 'clsx';

import { ANCHOR_PREFIX } from '$const';
import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import useLabels from '~hooks/useLabels';
import { IEntityComponentProps } from '~interfaces/props';
import { makeSlugForAnchorEntity } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';
import styles from './ModuleAnchor.module.css';

function appendHiddenIndicator(value: string, append = true) {
  const hiddenIndicator = '*';
  const cleanValue = value.replaceAll(hiddenIndicator, '').trim();
  const fixedValue = append ? `${cleanValue} ${hiddenIndicator}` : cleanValue;
  return fixedValue;
}

export const ModuleAnchor = ({ data, editing, className, onChange, canEdit }: IEntityComponentProps) => {
  const { msgAnchorModuleHeadlineHidden } = useLabels(['msgAnchorModuleHeadlineHidden']);

  // Do not render if there is no data!
  if (!data) {
    return null;
  }

  // Get field values
  const fieldHideTitle = data.attributes.field_hide_title || false;

  // derived values
  const hideTitle = canEdit ? false : fieldHideTitle;
  const showHiddenIndicator = canEdit && fieldHideTitle;
  const dataTitle = data.attributes.field_title.value;
  const title = appendHiddenIndicator(dataTitle, showHiddenIndicator);
  const moduleId = getModuleUrlIdFromData(data.id, data.type);
  const anchorId = `${ANCHOR_PREFIX}${makeSlugForAnchorEntity(data)}`;

  // styles
  const clsModule = clsx({ ...className.module, 'headline-is-hidden': hideTitle });
  const clsContainer = clsx({ ...className.container }, 'px-0 relative');
  const clsAnchor = clsx(styles.anchorPlacement, 'anchor-id-placement');

  return (
    <div className={clsModule} id={moduleId}>
      <div className={clsContainer} title={showHiddenIndicator ? msgAnchorModuleHeadlineHidden : ''}>
        <div id={anchorId} className={clsAnchor} />
        <EditableField
          hide={hideTitle}
          entityType={data.type}
          fieldName="attributes.field_title.value"
          data={title}
          editing={editing}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default ModuleAnchor;
